import React from 'react';
import { white } from './colors';
import { styled } from 'styled-components';

const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  cursor: pointer;
  font-weight: bold;
`;

const MainText = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`;

const SubText = styled.div``;

const RadioItem = styled.div<{
  $selected: boolean;
  $highlightSelect?: boolean;
}>`
  color: ${white};
  background: ${(props) => (props.$selected ? white : 'none')};
  color: ${(props) => (props.$selected ? '#26386b' : white)};
  flex-shrink: 0;
  padding: 0.3rem 0.5rem;
  border-color: ${white};
  border-style: solid;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 0.2rem;
  border-bottom-width: 0.2rem;
  flex-grow: 1;

  &:first-child {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    border-left-width: 0.2rem;
  }

  &:last-child {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    border-right-width: 0.2rem;
  }

  border: ${(props) =>
    props.$selected && props.$highlightSelect
      ? '0.2rem solid white'
      : undefined};
  border: 0.2rem solid white;
  border-right-width: 0rem;
  border-left-width: 0rem;
`;

export type RadioButtonOption = {
  id: string;
  main: string;
  sub?: string;
};

export const RadioButton: React.FC<{
  className?: string;
  options: RadioButtonOption[];
  selected: string;
  onSelect: (selectedOption: string) => void;
  highlightSelect?: boolean;
}> = ({ options, selected, onSelect, className, highlightSelect }) => {
  return (
    <RadioGroup className={className}>
      {options.map((option) => (
        <RadioItem
          $selected={option.id === selected}
          $highlightSelect={highlightSelect}
          onClick={() => onSelect(option.id)}
          key={`radio-${option.id}`}
        >
          <MainText>{option.main}</MainText>
          {option.sub && <SubText>{option.sub}</SubText>}
        </RadioItem>
      ))}
    </RadioGroup>
  );
};
